import { check_icon, info_icon, x_icon } from 'constant/AllIcons'
import { feature_groups, pricing_features } from 'data/Pricing/PricingFeaturesData'
import { pricing_features_package_relations } from 'data/Pricing/PricingFetauresPackageRelationData'
import { useRouter } from 'next/router'
import React, { useEffect } from 'react'

function FeaturesTable() {
  const router = useRouter()
  const features_list_with_group = feature_groups?.map((feature_group) => {
    return {
      group_name: feature_group?.title,
      key_name: feature_group.group_key,
      list_of_features: Object.keys(pricing_features)
        .filter((pf_key) => pricing_features[pf_key]?.group_key === feature_group?.group_key)
        ?.map((key_name) => ({
          ...pricing_features[key_name],
          key_name: key_name,
          package_relations: pricing_features_package_relations[key_name],
        })),
    }
  })

  useEffect(() => {
    // Check if there is a hash in the URL
    if (router.asPath.includes('#')) {
      const elementId = router.asPath.split('#')[1]
      const element = document.getElementById(elementId)

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center', // Scroll to center the element
        })
      }
    }
  }, [router.asPath])

  return (
    <section>
      <div className=" bg-white z-50 sticky top-0 ">
        <div className="  max-w-6xl mx-auto px-4 sm:px-6 ">
          {/* Section header */}
          <div className="pb-12">
            <a id="features" className="h2">
              Package Comparison
            </a>
          </div>
          {/* Table */}
          <div className="  ">
            <table className="table-fixed w-full border-b border-gray-200">
              {/* Table header */}
              <thead className="  sticky top-0    bg-white z-50 shadow-md">
                <tr className="  text-xs md:text-lg border-t border-gray-200">
                  <th className=" text-left pr-2 py-4 w-[25%] md:w-[35%]">Breakdown of features</th>
                  <th className=" text-center md:px-2 py-4">Community</th>
                  <th className=" text-center md:px-2 py-4">Starter</th>
                  <th className=" text-center md:px-2 py-4">Growth</th>
                  <th className=" text-center md:pl-2 py-4">Scale</th>
                </tr>
              </thead>
              {/* Table body */}
              <tbody className="overflow-x-scroll ">
                {features_list_with_group?.map((item, index) => {
                  return (
                    <>
                      {index !== 0 && (
                        <h3 id={item?.key_name} className=" dh3 py-6  whitespace-nowrap">
                          {item?.group_name}
                        </h3>
                      )}
                      {item?.list_of_features?.map((f_item) => {
                        const package_data = f_item?.package_relations

                        return (
                          <tr className="border-t border-gray-200 grid-cols-4 tooltip">
                            <td className="  text-xs md:text-base pr-2 py-4  flex items-center justify-between md:justify-start gap-1 ">
                              {f_item?.title}

                              {f_item?.item_info && (
                                <div className=" group">
                                  <span className=" cursor-pointer">{info_icon}</span>
                                  <span className=" hidden  absolute group-hover:block bg-gray-600 text-gray-50 text-sm  mt-2 text-start p-2 z-20 rounded-md max-w-xs">
                                    {f_item?.item_info}
                                  </span>
                                </div>
                              )}
                            </td>

                            <td className=" text-[8px] md:text-sm md:px-2 py-4 text-center md:font-medium">
                              {package_data?.community?.type === 'text'
                                ? package_data?.community?.value
                                : package_data?.community?.type === 'number'
                                ? package_data?.community?.value.toLocaleString()
                                : package_data?.community?.value
                                ? check_icon
                                : x_icon}
                            </td>
                            <td className=" text-[8px] md:text-sm md:px-2 py-4 text-center md:font-medium">
                              {package_data?.starter?.type === 'text'
                                ? package_data?.starter?.value
                                : package_data?.starter?.type === 'number'
                                ? package_data?.starter?.value.toLocaleString()
                                : package_data?.starter?.value
                                ? check_icon
                                : x_icon}
                            </td>
                            <td className=" text-[8px] md:text-sm md:px-2 py-4 text-center md:font-medium">
                              {' '}
                              {package_data?.growth?.type === 'text'
                                ? package_data?.growth?.value
                                : package_data?.growth?.type === 'number'
                                ? package_data?.growth?.value.toLocaleString()
                                : package_data?.growth?.value
                                ? check_icon
                                : x_icon}
                            </td>
                            <td className=" text-[8px] md:text-sm md:px-2 py-4 text-center md:font-medium">
                              {' '}
                              {package_data?.scale?.type === 'text'
                                ? package_data?.scale?.value
                                : package_data?.scale?.type === 'number'
                                ? package_data?.scale?.value.toLocaleString()
                                : package_data?.scale?.value
                                ? check_icon
                                : x_icon}
                            </td>
                          </tr>
                        )
                      })}
                    </>
                  )
                })}
              </tbody>
            </table>
          </div>
          <div className="mt-7">
            <p>
              *1 – Example of Platform Subscription – A platform like Depop requires it’s seller to
              pay monthly subscription if they want to sell more than 5 item-{' '}
            </p>
            <p>
              *2 – Example of Product subscription – A customer subscribing to a monthly
              subscription of meal box{' '}
            </p>
            <p>
              *3 – When a payment gateway provides only payments, then the all the transacted money
              will go directly to your bank account. You need to manage payouts manually to your
              sellers/service providers in marketplace{' '}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeaturesTable
